
import External from './components/External';

export default {
  i18nComponentKey: 'WidgetProductReviewsExternal.WidgetProductReviewsExternalMobile',
  name: 'WidgetProductReviewsExternalMobile',
  components: { External }
};
